export const currency = (state) => state.currency;
export const defaultCurrency = (state) => currency(state).defaultCurrency;
export const defaultCurrencySign = (state) => currency(state).defaultCurrencySign;
export const defaultWSCurrency = (state) => currency(state).defaultWSCurrency;
export const isDualCurrency = (state) => currency(state).isDualCurrency;
export const isCurrencyConversionChecked = (state) => currency(state).isCurrencyConversionChecked;
export const isMatchFinancials = (state) => currency(state).isMatchFinancials;
export const selectedCurrencyCode = (state) => currency(state).selectedCurrencyCode;
export const getCurrencyData = (state) => currency(state).currencyData;
export const getCurrencyReducerState = (state) => state.currency;